import useSiteMetadata from "./useSiteMetaData"

const useComposeUrl = (pathname) => {
  const metaData = useSiteMetadata();

  return `${metaData.siteUrl}${pathname}`;
}

export default useComposeUrl;
